<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Penyelenggara
      <template v-if="role_status && role_status.status_create">
        <CButton color="success" class="btn-md ml-auto" @click="createData()">Tambah</CButton>
      </template>
    </CCardHeader>
    <!-- Data Workshop -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id @change="changePageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id 
            class="form-control" 
            v-model="search"
            placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
             <template #nama_penyelenggara="{item}">
              <td class="py-2">{{ item.nama_penyelenggara ? item.nama_penyelenggara : '-'}}</td>
            </template>
             <template #bank="{item}">
              <td class="py-2">{{ item.bank ? item.bank : '-'}}</td>
            </template>
             <template #nama_akun="{item}">
              <td class="py-2">{{ item.nama_akun ? item.nama_akun : '-'}}</td>
            </template>
            <template #nama_tipe_pengelola="{item}">
              <td class="py-2">{{ item.nama_tipe_pengelola ? item.nama_tipe_pengelola : '-'}}</td>
            </template>
  
             <template #nama_kota_kab="{item}">
              <td class="py-2">{{ item.nama_kota_kab ? item.nama_kota_kab : '-'}}</td>
            </template>
             <template #no_rekening="{item}">
              <td class="py-2">{{ item.no_rekening ? item.no_rekening : '-'}}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mr-1" @click="updateData(item, index)" square>
                  <font-awesome-icon icon="edit"  />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" class="btn-sm mr-1" disabled square>
                  <font-awesome-icon icon="edit"  />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" class="btn-sm" square disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label for="nama_penyelenggara" class="font-weight-bold">Nama Penyelenggara</label>
                  <input
                    type="text"
                    class="form-control"
                    id="nama_penyelenggara"
                    placeholder="Masukkan nama penyelenggara"
                    v-model="formData.namaPenyelenggara"                    
                    @input="setNamaPenyelenggara($event.target.value)"                    
                    :class="{
                      'is-invalid': $v.formData.namaPenyelenggara.$error                
                    }"
                  />
                </div>
                <div class="form-group">
                  <label for="tipePengelola" class="font-weight-bold">Pilih Tipe Penyelenggara</label>
                  <multiselect
                      label="namaTipePengelola"
                      placeholder="Pilih tipe penyelanggara"
                      id="tipePengelola"
                      @select="updateSelectTipe"
                      v-model="datatipepengelola"
                      :options="tipePengelola"
                      v-bind:class="{
                        'border-danger': $v.formData.idTipePengelola.$error ? true : false
                      }"
                    ></multiselect>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="kotaKab" class="font-weight-bold">Kota/Kab</label>                    
                    <multiselect
                      label="name"
                      placeholder="Pilih Kota/Kab"
                      id="kotaKab"
                      @select="updateSelect"
                      v-model="datakotakab"
                      :options="KotaKab"
                      :class="{
                        'border-danger': $v.formData.idKotaKab.$error                
                      }"
                    ></multiselect>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="nama_bank font-weight-bold" class="font-weight-bold">Nama Bank</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama_bank"
                      oninput="this.value = this.value.toUpperCase()"
                      placeholder="Masukkan nama bank"
                      v-model="formData.bank"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label
                      for="no_rekening"
                      class="font-weight-bold"
                    >Nomor Rekening</label>
                    <input
                      type="number"
                      class="form-control"
                      id="no_rekening"
                      placeholder="Masukkan nomor rekening"
                      v-model="formData.noRekening"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="nama_akun" class="font-weight-bold">Nama Akun</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama_akun"
                      placeholder="Masukkan nama akun"
                      v-model="formData.namaAkun"
                    />
                  </div>
                </div>
                <CCol sm="12 pl-0">
                  <label for class="font-weight-bold">Status</label>
                  <br />
                  <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        id="aktif"
                        value="1"
                        v-model="formData.status"
                      />
                      <label class="custom-control-label" for="aktif">Aktif</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        id="tidak_aktif"
                        value="0"
                        v-model="formData.status"
                      />
                      <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                    </div>
                  </div>
                  <span v-if="$v.formData.status.$error" class="text-danger mt-1">
                    *Mohon pilih status
                  </span>
                </CCol>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data provinsi -->
  </CCard>
</template>
<script>
import { required } from 'vuelidate/lib/validators'

import KotaKabupatenService from "@/services/datamaster/kota-kabupaten.service";
import PenyelenggaraService from "@/services/pelatihan/penyelenggara.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";


const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "nama_penyelenggara",
    label: "Nama Penyelenggara",
    sorter: true,
    filter: false
  },
  {
    key: "nama_tipe_pengelola",
    label: "Tipe",
    sorter: true,
    filter: false
  },
  {
    key: "bank",
    label: "Bank",
    sorter: true,
    filter: false
  },
  {
    key: "no_rekening",
    label: "Nomor Rekening",
    sorter: true,
    filter: false
  },
  {
    key: "nama_akun",
    label: "Nama Akun",
    sorter: true,
    filter: false
  },
  {
    key: "nama_kota_kab",
    label: "Kota/Kab",
    sorter: true,
    filter: false
  },
  {
    key: "status",
    label: "Status Aktif",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils,Pagination],
  data() {
    return {
      items:[],
      datakotakab: [],
       search: "",
      datatipepengelola:[],
      KotaKab: [],
      tipePengelola:[],
      pageSize: "",
      formData: {
        bank: "",
        idKotaKab: "",
        idTipePengelola: "",
        namaAkun: "",
        namaPenyelenggara: "",
        noRekening: "",
        status: "",
        idPenyelenggara:null,
        id_user: "",
      },
      pagination: {
        totalPages: 0
      },
      fields,
      title : '',
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      timeout : null,
      awaitingSearch : false,
      actionPost: "",
      role_status: null
      
    };
  },

  validations: {
    formData: {
      idKotaKab: { required },
      idTipePengelola: { required },
      namaPenyelenggara: { required },
      status: { required },
    }
  },

  mounted() {
    this.roleData();
    this.getKotaKab();
    this.getData("0", this.pageSize, this.search);
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    setNamaPenyelenggara(value) {
      this.formData.namaPenyelenggara = value;
      this.$v.formData.namaPenyelenggara.$touch();
      if(!this.$v.formData.namaPenyelenggara.$error) {
        document.getElementById("nama_penyelenggara").classList.add("is-valid")
      }
    },
    setNamaBank(value) {
      this.formData.bank = value;
      this.$v.formData.bank.$touch();
      if(!this.$v.formData.bank.$error) {
        document.getElementById('nama_bank').classList.add('is-valid')
      }
    },
    setNoRekening(value) {
      this.formData.noRekening = value;
      this.$v.formData.noRekening.$touch();
      if(!this.$v.formData.noRekening.$error) {
        document.getElementById('no_rekening').classList.add('is-valid');
      }
    },
    setNamaAkun(value) {
      this.formData.namaAkun = value;
      this.$v.formData.namaAkun.$touch();
      if(!this.$v.formData.namaAkun.$error) {
        document.getElementById('nama_akun').classList.add('is-valid');
      }
    },    

    cariData() {
      this.getData("0", this.pageSize, this.search);
    },
     pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    getData(currentPage, pageSize, filter) {
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PenyelenggaraService.getPenyelenggara(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response.data);

          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;          
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.formData = {
        "bank": item.bank,
        "idKotaKab": item.id_kota_kab,
        "idTipePengelola": item.id_tipe_pengelola,
        "namaAkun": item.nama_akun,
        "namaPenyelenggara":item.nama_penyelenggara,
        "noRekening": item.no_rekening,
        "status": item.status,
        "idPenyelenggara":item.id_penyelenggara
      };

      // comment console console.log("ini update ", item);
      this.datatipepengelola = [
        {
          namaTipePengelola: item.nama_tipe_pengelola
        }
      ];
      this.datakotakab = [
        {
          name: item.nama_kota_kab
        }
      ];
      this.myModal = true;
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      this.$v.$touch();           
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.insertData(this.formData);
        }
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        }        
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;
      PenyelenggaraService.postPenyelenggara(formData)
        .then(response => {
          loader.hide();
          vm.myModal = false;
          vm.alertSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError();
        });
    },

    putData() {
        // comment console console.log("put");
        // comment console console.log(this.formData);
        var vm = this;
        PenyelenggaraService.putPenyelenggara(this.formData)
          .then(response => {
            vm.myModal = false;

            vm.alertEditSuccess();
            vm.getData("0", this.pageSize, this.search);
          })
          .catch(error => {
            // comment console console.log(error);

            vm.alertError();
          });
    },

    pageChange() {      
      this.getData(currentPage, this.pageSize, this.search);
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item, index) {
      // this.formData = item;
      // // comment console console.log("form data boy ",  this.formData);
      this.$swal

        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })

        .then(result => {
          if (result.value) {
              PenyelenggaraService.deletePenyelenggara(item)
              .then(response => {
                // comment console console.log(response);
                var vm = this;
                const Toast = vm.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  onOpen: toast => {
                    toast.addEventListener("mouseenter", vm.$swal.stopTimer);
                    toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
                  }
                });
                Toast.fire({
                  icon: "success",
                  title: "Data Berhasil Dihapus"
                });
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.$swal.fire({
                  title: "Peringatan !",
                  text: error.response.data.message,
                  icon: "errorr",
                  showCancelButton: true
                });
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getKotaKab() {
      var vm = this;
      KotaKabupatenService.getAll()

        .then(response => {
          // comment console console.log(response.data.data.content);
          PenyelenggaraService.getTipePengelola()
          .then(response2 => {
            // comment console console.log("data tipe" , response2.data.data);
            vm.tipePengelola = response2.data.data;
          })
          .catch(error2 => {
            // comment console console.log(error2);
          });
          vm.KotaKab = response.data.data.content;
          // comment console console.log("data kab" , response.data.data.content);
        })

        .catch(error => {
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      // comment console console.log("event ", event)
      var vm = this;
      this.formData.idKotaKab = event.id_kota_kab;
    },

    updateSelectTipe(event) {
      // comment console console.log("event tipe", event)      
      var vm = this;
      this.formData.idTipePengelola = event.idTipePengelola;
    },

    clearValidations() {
      this.$v.$reset();      
    }
}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>